import React from "react";
import { Bell, BellDot } from "lucide-react";
import { useNotifications } from "../../hooks/useNotifications";
import { useLocalization } from "../../hooks/useLocalization";
import { formatJst } from "../../lib/date";
import { EagleState } from "../../components/EagleState";
import { PageHelpBanner } from "../../components/PageHelpBanner";

export default function MyNotificationsPage() {
  const { notifications, markRead } = useNotifications();
  const { t, language } = useLocalization();

  return (
    <div data-testid="my-notifications-page" className="space-y-4">
      <PageHelpBanner pageKey="my-notifications" title="How to use this page">
        <p>Click any notification to mark it as read - unread items are highlighted in blue with a filled bell icon.</p>
      </PageHelpBanner>
      <h2 className="text-xl font-bold tracking-tight text-gray-900">{t("nav.myNotifications")}</h2>
      <div className="space-y-2">
        {notifications.map((n) => (
          <button
            key={n.id}
            data-testid={`notification-item-${n.id}`}
            onClick={() => !n.is_read && markRead(n.id)}
            className={`w-full text-left flex items-start gap-3 p-4 rounded-xl border transition-colors ${
              n.is_read ? "border-gray-200 bg-white" : "border-blue-200 bg-blue-50"
            }`}
          >
            {n.is_read ? <Bell size={18} className="text-gray-300 mt-0.5" /> : <BellDot size={18} className="text-blue-500 mt-0.5" />}
            <div>
              <p className="text-sm font-semibold text-gray-800">{language === "ja" ? n.title_ja : n.title_en}</p>
              <p className="text-xs text-gray-500">{language === "ja" ? n.body_ja : n.body_en}</p>
              <p className="text-[11px] text-gray-500 mt-1">{formatJst(n.created_at)}</p>
            </div>
          </button>
        ))}
        {notifications.length === 0 && <EagleState variant="empty" title={t("eagle.noNotificationsTitle")} message={t("eagle.noNotificationsMessage")} testId="notifications-empty" />}
      </div>
    </div>
  );
}
